import dayjs from '../../utils/dayjs';
import { OrderType } from '../../types';
import type { HistoricalOrderItem } from '../order/HistoricalOrderItem';
import type {
  ContactDetailsDto,
  CustomerOrderDetailsDto,
} from '@kotipizzagroup/kotipizza-users-api-client';
import type { PricingDetails } from '../../components/shoppingCart/types';

export class HistoricalOrder {
  constructor(data: CustomerOrderDetailsDto, orderItems: HistoricalOrderItem[]) {
    this.orderPlacedAt = dayjs(data.orderPlacedAt);
    this.preOderTime = data.preOrderTime ? dayjs(data.preOrderTime) : null;
    this.orderId = data.orderId;
    this.orderItems = orderItems;
    this.grandTotal = data.grandTotal;
    this.orderType = data.deliveryMethod.toLowerCase() as OrderType; // TODO: Fix enum type
    this.restaurantId = data.shopId;
    this.contactDetails = data.contactDetails;
    this.phoneOrderFee = data.phoneOrderFee;
    this.deliveryServiceFee = data.deliveryServiceFee || 0;
    this.pricingDetails = data.pricingDetails as PricingDetails;
    this.shippingCharges = data.shippingCharges;
    this.grandTotalWithoutShippingAndDiscounts = data.grandTotalWithoutShippingAndDiscounts;
    this.discountsSum = data.discountsSum;
  }

  public orderId: number;
  public orderPlacedAt: dayjs.Dayjs;
  public orderItems: HistoricalOrderItem[] = [];
  public grandTotal: number = 0;
  public phoneOrderFee: number = 0;
  public deliveryServiceFee: number = 0;
  public orderType: OrderType = OrderType.DELIVERY;
  public restaurantId: number = 0;
  public preOderTime: dayjs.Dayjs | null = null;
  public discountsSum: number = 0;
  public grandTotalWithoutShippingAndDiscounts: number = 0;
  public shippingCharges: number = 0;
  public pricingDetails: PricingDetails;
  public contactDetails: ContactDetailsDto;

  public getTotalItemQuantity(): number {
    return this.orderItems.reduce((total, item) => total + item.quantity, 0);
  }

  public includesInactiveProducts(): boolean {
    return this.orderItems.some(
      (orderItem) =>
        orderItem.inactive || orderItem.includesInactiveIngredients || orderItem.recipeOutdated
    );
  }
}
